<div id="imprint">
    <h1>Imprint</h1>

    Please note that an imprint is not required according to § 5 TMG (German Act for Telemedia Services) since this
    website serves private purposes only.<br />
    Feel free to contact me via XING or LinkedIn.
</div>